import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import logo_white from '../assets/img/logo_white.png'
import { BsInstagram } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

export const Footer = () => {

  const location = useLocation()
  
  return (
    <footer className={"footer text-white" + (location.pathname === '/checkout' ? " hidden" : "")} id="footer">
      <div className="w-full mx-auto innerContainer py-20 flex flex-col gap-10">
        <div className="flex gap-x-10 gap-y-10 flex-col sm:flex-row sm:justify-between">
          <div className="flex-[1] flex flex-col justify-between h-auto gap-10">
            <div className="flex flex-col gap-5">
              <Link to="/" className="w-fit"><img src={logo_white} className="w-40" /></Link>
              <p className="hidden md:block text-sm text-neutral-200">
                BogBanken.dk er din online markedsplads for brugte bøger – uanset om du leder efter spændende romaner, faglitteratur, studiebøger eller noget helt fjerde. Find og sælg bøger nemt og trygt med sikker betaling.
              </p>
              <p className="md:hidden text-sm text-neutral-200">BogBanken.dk er markedspladsen for brugte bøger. Sælg nemt og køb trygt – alt samlet ét sted.</p>
            </div>
          </div>
          <div className="flex gap-10 justify-none md:justify-around md:flex-[1]">
            <div className="links sm:flex flex-col gap-5 hidden">
              <h2 className="font-semibold select-none">Links</h2>
              <div className="flex flex-col gap-2 list-none">
                <Link to="/">
                  <li className="hover:text-emerald-500 transition-[]">
                      Forside
                  </li>
                </Link>
                <Link to="/bøger">
                  <li className="hover:text-emerald-500 transition-[]">
                    Bøger
                  </li>
                </Link>
                <Link to="/hjælp">
                  <li className="hover:text-emerald-500 transition-[]">
                    Hjælp
                  </li>
                </Link>
                <Link to="/kontakt">
                  <li className="hover:text-emerald-500 transition-[]">
                    Kontakt
                  </li>
                </Link>
              </div>
            </div>
            <div className="contact flex flex-col gap-5">
              <h2 className="font-semibold select-none">Kontakt</h2>
              <div className="flex flex-col gap-2 list-none">
                <li className="">
                    Tlf. 21 13 43 26
                </li>
                <li className="">
                  kontakt@bogbanken.dk
                </li>
              </div>
              <div className="address text-nowrap">
                <p>Linnemannsgade 1B, 3. tv</p>
                <p>7100, Vejle</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex text-3xl gap-4">
          <FaFacebookF className="py-[0.05rem] cursor-pointer" />
          <BsInstagram className="cursor-pointer" />
        </div>
      </div>
    </footer>
  )
}